
// vue
import { ref, defineComponent } from 'vue';

// firebase
import 'firebase/firestore';

// atoms
import Modal from '@/components/atoms/Modal.vue';
import TextField from '@/components/atoms/TextField.vue';
// molecules
import ModalContent from '@/components/molecules/ModalContent.vue';

export default defineComponent({
  name: 'LaunchAdminScreen',
  components: {
    Modal,
    TextField,
    ModalContent,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close'],
  setup() {
    const url = location.href;
    const studentRoomURL = ref(url.replace('admin', 'student'));
    return { studentRoomURL };
  },
});
